// removed by extract-text-webpack-plugin
module.exports = {"item-list":"src-components-PpeItemList----PpeItemList-module---item-list---3ph60"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PpeItemList/PpeItemList.module.scss
// module id = 1194
// module chunks = 137591856104208